<mat-card class="card-pass">
  <mat-card-content>
    <!--Action button-->
    <div class="mb-24">
      <button mat-flat-button [class.mat-accent]="billingMode === 'LEGAL'" class="mr-16" (click)="onChangeBillingMode('LEGAL')">Fattura con Partita IVA</button>
      <button mat-flat-button [class.mat-accent]="billingMode === 'INDIVIDUAL'" class="mr-16" (click)="onChangeBillingMode('INDIVIDUAL')">Fattura con Codice Fiscale</button>
    </div>
    <!--form LEGAL -->
    @if (billingMode === 'LEGAL') {
      <div>
        <!--start search profile-->
        <label>Ricerca un profilo associato alla Partita IVA oppure creane uno nuovo.</label>
        <div class="fx-row fx-justify-start fx-items-baseline" style="gap: 3px">
          <!--input search-->
          <div class="fx-flex">
            <form-input-viewer
              [formInputDefinition]='fields.get("p_iva_search")'
              [formGroup]='searchFromGroup'
              formControlKey='p_iva_search'
            ></form-input-viewer>
          </div>
          <!--Serach button-->
          <div class="ml-4 fx-flex">
            @if (!loading) {
              <button (click)="onSearchProfile()" mat-flat-button color='accent'>{{'Cerca' | translate}}</button>
            }
            @if (loading) {
              <mat-spinner diameter="20" matSuffix></mat-spinner>
            }
          </div>
          <div class="fx-flex">
            <form-input-viewer
              [formInputDefinition]='fields.get("create_new_profile")'
              [formGroup]='searchFromGroup'
              formControlKey='create_new_profile'
            ></form-input-viewer>
          </div>
        </div>
        <!--end search profile-->
        <!--billing data-->
        <label>Dati Fatturazione</label>
        <div class="fx-row fx-wrap" style="align-items: baseline; gap: 3px">
          @if (!isInvoiceProfiles) {
            <div class="fx-flex">
              <form-input-viewer
                [readOnly]="!creaNewProfile"
                [formInputDefinition]='fields.get("profile_name")'
                [formGroup]='formViewerService.formGroup'
                [formControlKey]='formViewerService.controlKeyMap["profile_name"]'
              ></form-input-viewer>
            </div>
          }
          @if (isInvoiceProfiles) {
            <mat-form-field class="mr-3px fx-flex">
              <mat-label>Nome profilo</mat-label>
              <mat-select (selectionChange)='onSelectInvoiceProfile($event)'>
                @for (profile of invoiceProfiles; track profile) {
                  <mat-option [value]="profile">
                    {{profile.name}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          <div class="fx-flex">
            <form-input-viewer
              [readOnly]="!creaNewProfile"
              [formInputDefinition]='fields.get("business_name")'
              [formGroup]='formViewerService.formGroup'
              [formControlKey]='formViewerService.controlKeyMap["business_name"]'
            ></form-input-viewer>
          </div>
          <div class="fx-flex">
            <form-input-viewer
              [readOnly]="!creaNewProfile"
              [formInputDefinition]='fields.get("p_iva")'
              [formGroup]='formViewerService.formGroup'
              [formControlKey]='formViewerService.controlKeyMap["p_iva"]'
            ></form-input-viewer>
          </div>
        </div>
        <div class="fx-row fx-wrap" style="gap: 3px">
          <div class="fx-flex">
            <form-input-viewer
              [readOnly]="!creaNewProfile"
              [formInputDefinition]='fields.get("corporate_tax_code")'
              [formGroup]='formViewerService.formGroup'
              [formControlKey]='formViewerService.controlKeyMap["corporate_tax_code"]'
            ></form-input-viewer>
          </div>
          <div class="fx-flex">
            <form-input-viewer
              [readOnly]="!creaNewProfile"
              [formInputDefinition]='fields.get("country_select")'
              [formGroup]='formViewerService.formGroup'
              [formControlKey]='formViewerService.controlKeyMap["country"]'
            ></form-input-viewer>
          </div>
          <div class="fx-flex">
            <form-input-viewer
              [readOnly]="!creaNewProfile"
              [formInputDefinition]='fields.get("province")'
              [formGroup]='formViewerService.formGroup'
              [formControlKey]='formViewerService.controlKeyMap["province"]'
            ></form-input-viewer>
          </div>
        </div>
        <div class="fx-row fx-wrap" style="gap: 3px">
          <div class="fx-flex">
            <form-input-viewer
              [readOnly]="!creaNewProfile"
              [formInputDefinition]='fields.get("city")'
              [formGroup]='formViewerService.formGroup'
              [formControlKey]='formViewerService.controlKeyMap["city"]'
            ></form-input-viewer>
          </div>
          <div class="fx-flex">
            <form-input-viewer
              [readOnly]="!creaNewProfile"
              [formInputDefinition]='fields.get("cap")'
              [formGroup]='formViewerService.formGroup'
              [formControlKey]='formViewerService.controlKeyMap["cap"]'
            ></form-input-viewer>
          </div>
          <div class="fx-flex">
            <form-input-viewer
              [readOnly]="!creaNewProfile"
              [formInputDefinition]='fields.get("address")'
              [formGroup]='formViewerService.formGroup'
              [formControlKey]='formViewerService.controlKeyMap["address"]'
            ></form-input-viewer>
          </div>
        </div>
        <!--end billing data-->
        <!--mode of delivery-->
        <label>Obbligatorio Cod.Dest. o PEC</label>
        <div class="fx-row fx-wrap" style="gap: 3px">
          <div class="fx-flex">
            <form-input-viewer
              [readOnly]="!creaNewProfile"
              [formInputDefinition]='fields.get("recipient_code")'
              [formGroup]='formViewerService.formGroup'
              [formControlKey]='formViewerService.controlKeyMap["recipient_code"]'
            ></form-input-viewer>
          </div>
          <div class="fx-flex">
            <form-input-viewer
              [readOnly]="!creaNewProfile"
              [formInputDefinition]='fields.get("pec")'
              [formGroup]='formViewerService.formGroup'
              [formControlKey]='formViewerService.controlKeyMap["pec"]'
            ></form-input-viewer>
          </div>
        </div>
        <!--end mode of delivery-->
      </div>
    }
    <!--end form LEGAL -->

    <!--form INDIVIDUAL -->
    @if (billingMode === 'INDIVIDUAL') {
      <div>
        <trenitalia-billing-form-individual [billingData]="billingData"></trenitalia-billing-form-individual>
      </div>
    }
    <!--end form INDIVIDUAL -->
  </mat-card-content>
</mat-card>